<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentUrl /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentUrl from '@/components/worker/dashboard/modules/activity/url/ContentUrl.vue'

export default 
{
  name: 'Url',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentUrl
  }
}
</script>
<style>

</style>